import React, { useState, useEffect } from "react";
import NewModelModal from "./Modal";
import { useAuth } from "../services/auth.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faSearch, 
  faPlus, 
  faEdit, 
  faTrash, 
  faFileAlt,
  faSpinner,
  faFilter,
  faTimes,
  faImage,
  faVideo,
  faTag,
  faCog,
  faComment,
  faReply,
  faEye,
  faCheck
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { 
  Box, 
  Typography, 
  Card, 
  CardContent, 
  Button, 
  TextField, 
  IconButton,
  Chip,
  Avatar,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Alert,
  Snackbar,
  LinearProgress,
  Tooltip,
  Fab,
  Badge,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled components
const StyledCard = styled(Card)(({ theme }) => ({
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  borderRadius: '16px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
  },
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: '12px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  overflow: 'hidden',
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 600,
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef',
}));

const SearchContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#f8f9fa',
  borderRadius: '12px',
  padding: '8px 16px',
  border: '1px solid #e9ecef',
  transition: 'all 0.3s ease',
}));

const TemplateCard = styled(Card)(({ theme }) => ({
  borderRadius: '12px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
  },
}));

export default function Template() {
  const [modalSubmitting, setModalSubmitting] = useState(false);
  const [modalResult, setModalResult] = useState("");
  const [templates, setTemplates] = useState([]);
  const [tempTemplates, setTempTemplates] = useState([]);
  const [currentFormAction, setCurrentFormAction] = useState("/");
  const [currentFormMethod, setCurrentFormMethod] = useState("POST");
  const [currentButtonText, setCurrentButtonText] = useState("Guardar");
  const [currentTitle, setCurrentTitle] = useState("Nueva Plantilla");
  const [modalBody, setModalBody] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user, logout, currentConfig, changeCurrentConfig, getCurrentConfig } = useAuth();
  const [searchValue, setSearchValue] = useState("");
  const [viewMode, setViewMode] = useState('table'); // 'table' or 'grid'
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [formData, setFormData] = useState({});
  
  // New WhatsApp Cloud API states
  const [waTemplates, setWaTemplates] = useState([]);
  const [templateStats, setTemplateStats] = useState({
    total: 0,
    approved: 0,
    pending: 0,
    rejected: 0,
    disabled: 0
  });
  const [syncLoading, setSyncLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState('all');
  const [showWaTemplates, setShowWaTemplates] = useState(false);

  const defaultModalBody = [
    {
      id: "name",
      name: "name",
      type: "text",
      placeholder: "Nombre_Plantilla",
      value: "",
    },
    {
      id: "body",
      name: "body",
      type: "textarea",
      placeholder: "_*Hola*_\n\nLe informamos que fue APROBADO el trámite\nAsegurado *{{1}}*\nCédula *{{2}}*\nIniciado el día *{{3}}*\nSuma asegurada $*{{4}}*\n\n*_Gracias_*",
      value: "",
    },
    {
      id: "source",
      name: "source",
      type: "select-datasource",
      dataSource: "/sources",
      multiselect: false,
      value: "",
      defaultValue: "",
      limit: 1,
      placeholder: "Plantilla Fuente",
      nextSourceIds: ["parameters", "buttonparameters", "phoneparameter", "agentparameter"],
    },
    {
      id: "parameters",
      name: "parameters",
      type: "select",
      dataSource: "/renovaciones/polizas/columns",
      multiselect: true,
      value: "",
      defaultValue: [],
      limit: 7,
      placeholder: "Parametros",
    },
    {
      id: "image-video-select",
      name: "image-video-select",
      type: "select-show",
      defaultValue: [{ value: "image", label: "image" }],
      value: [{ value: "image", label: "image" }],
      optionIds: ["image", "video"]
    },
    {
      id: "image",
      name: "image",
      type: "text",
      placeholder: "https://ejemplo.com/imagen.png",
      value: "",
    },
    {
      id: "video",
      name: "video",
      type: "hidden",
      placeholder: "https://ejemplo.com/video.mp4",
      value: "",
    },
    {
      id: "buttonparameters",
      name: "buttonparameters",
      type: "select",
      dataSource: "/renovaciones/polizas/columns",
      multiselect: true,
      value: "",
      defaultValue: [],
      limit: 2,
      placeholder: "Parametros_Boton",
    },
    {
      id: "buttonparameterindex",
      name: "buttonparameterindex",
      type: "number",
      placeholder: "1 o 0",
      value: "0",
    },
    {
      id: "agentbuttonparameters",
      name: "agentbuttonparameters",
      type: "select",
      dataSource: "/template?listnames=1",
      multiselect: true,
      value: "",
      limit: 1,
      placeholder: "Parametros_Boton_Agente",
    },
    {
      id: "agentbuttonparameterindex",
      name: "agentbuttonparameterindex",
      type: "number",
      placeholder: "1 o 0",
      value: "0",
    },
    {
      id: "phoneparameter",
      name: "phoneparameter",
      type: "select",
      dataSource: "/renovaciones/polizas/columns",
      multiselect: false,
      value: "",
      limit: 1,
      placeholder: "Columna_Telefono",
    },
    {
      id: "agentparameter",
      name: "agentparameter",
      type: "select",
      dataSource: "/renovaciones/polizas/columns",
      multiselect: false,
      value: "",
      limit: 1,
      placeholder: "Columna_Agente",
    },
    {
      id: "collection",
      name: "collection",
      type: "hidden",
      value: "renovacion",
      defaultValue: "renovacion",
    },
    {
      id: "is_monday",
      name: "is_monday",
      type: "checkbox",
      value: false,
      placeholder: "Es plantilla de Monday?",
    },
    {
      id: "is_flow",
      name: "is_flow",
      type: "checkbox",
      value: false,
      placeholder: "Es plantilla de flow?",
    },
  ];

  const customActionTemplate = [
    {
      id: "name",
      name: "name",
      type: "text",
      placeholder: "Nombre_Plantilla",
      value: "",
    },
    {
      id: "body",
      name: "body",
      type: "textarea",
      placeholder: "_*Hola*_\n\nLe informamos que fue APROBADO el trámite\nAsegurado *{{1}}*\nCédula *{{2}}*\nIniciado el día *{{3}}*\nSuma asegurada $*{{4}}*\n\n*_Gracias_*",
      value: "",
    },
    {
      id: "parameters",
      name: "parameters",
      type: "select",
      dataSource: "/renovaciones/polizas/columns",
      multiselect: true,
      value: "",
      defaultValue: [],
      limit: 7,
      placeholder: "Parametros",
    },
    {
      id: "image",
      name: "image",
      type: "text",
      placeholder: "https://ejemplo.com/imagen.png",
      value: "",
    },
    {
      id: "buttonparameters",
      name: "buttonparameters",
      type: "select",
      dataSource: "/template?listnames=1",
      multiselect: true,
      value: "",
      limit: 2,
      placeholder: "Parametros_Boton",
    },
    {
      id: "buttonparameterindex",
      name: "buttonparameterindex",
      type: "number",
      placeholder: "1 o 0",
      value: "0",
    },
    {
      id: "agentbuttonparameters",
      name: "agentbuttonparameters",
      type: "select",
      dataSource: "/template?listnames=1",
      multiselect: true,
      value: "",
      limit: 1,
      placeholder: "Parametros_Boton_Agente",
    },
    {
      id: "agentbuttonparameterindex",
      name: "agentbuttonparameterindex",
      type: "number",
      placeholder: "1 o 0",
      value: "0",
    },
    {
      id: "template_origin",
      name: "template_origin",
      type: "select",
      dataSource: "/collections",
      multiselect: false,
      value: "",
      defaultValue: "",
      limit: 1,
      placeholder: "Coleccion",
    },
    {
      id: "type",
      name: "type",
      type: "hidden",
      value: "quickreply",
      defaultValue: "quickreply",
    },
    {
      id: "collection",
      name: "collection",
      type: "hidden",
      value: "renovacion",
      defaultValue: "renovacion",
    },
    {
      id: "is_monday",
      name: "is_monday",
      type: "checkbox",
      value: false,
      placeholder: "Es plantilla de Monday?",
    },
    {
      id: "is_flow",
      name: "is_flow",
      type: "checkbox",
      value: false,
      placeholder: "Es plantilla de flow?",
    },
  ];

  const searchTemplate = (e) => {
    setSearchValue(e.target.value);
    if (e.target.value === "") {
      setTemplates(tempTemplates);
    } else {
      setTemplates(
        tempTemplates.filter((template) =>
          template.name.toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
    }
  };

  useEffect(() => {
    if (loading) return;
    async function fetchData() {
      setLoading(true);
      const url = process.env.REACT_APP_BACKEND_API + "/template";
      let config = {
        headers: {
          "x-access-token": user.accessToken,
          "Content-Type": "application/json",
        },
      }
      let result = await axios.get(url, config)
        .then((response) => {
          return response;
        }
        )
        .catch((error) => {
          return error;
        }
        );
      if (result.data) {
        setLoading(false);
        setTemplates(result.data);
        setTempTemplates(result.data);
      }
    }
    fetchData();
  }, []);

  const formOnChange = (e, action) => {
    try {
      const { name, value } = e.target;
      setModalBody(
        modalBody.map((item) => {
          if (item.name === name) {
            item.value = value;
          }
          return item;
        })
      );
    } catch (error) {
      const items = e;
      setModalBody(
        modalBody.map((bodyItem) => {
          if (
            (bodyItem.type === "select" || bodyItem.type === "select-show" || bodyItem.type === "select-datasource") &&
            bodyItem.name === action.name
          ) {
            bodyItem.value = items;
            return bodyItem;
          }
          return bodyItem;
        })
      );
    }
  };

  const newTemplate = (e) => {
    e.preventDefault();
    setModalBody(defaultModalBody);
    setCurrentTitle("Nueva Plantilla");
    setCurrentFormAction("/");
    setCurrentFormMethod("POST");
    setCurrentButtonText("Guardar");
    setFormData({});
    setDialogOpen(true);
  };

  const newTemplateQuickReply = (e) => {
    e.preventDefault();
    setModalBody(customActionTemplate);
    setCurrentTitle("Nueva Plantilla Quick Reply");
    setCurrentFormAction("/");
    setCurrentFormMethod("POST");
    setCurrentButtonText("Guardar");
    setFormData({});
    setDialogOpen(true);
  };

  const deleteTemplate = (e) => {
    e.preventDefault();
    const id = templates[e.currentTarget.dataset.id]._id;
    fetch(process.env.REACT_APP_BACKEND_API + "/template/" + id, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        'x-access-token': user.accessToken,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setTemplates(templates.filter((template) => template._id !== id));
        setTempTemplates(tempTemplates.filter((template) => template._id !== id));
        setSnackbar({ open: true, message: 'Template eliminado correctamente', severity: 'success' });
      })
      .catch((error) => {
        setSnackbar({ open: true, message: 'Error al eliminar template', severity: 'error' });
      });
  };

  const editTemplate = (e) => {
    e.preventDefault();
    const template = templates[e.currentTarget.dataset.id];
    setCurrentFormAction("/" + template._id);
    setCurrentFormMethod("PUT");
    setCurrentButtonText("Actualizar");
    setCurrentTitle(template.type === "quickreply" ? "Editar Plantilla Quick Reply" : "Editar Plantilla");
    
    // Convert template data to form data
    const formDataObj = {};
    modalBody.forEach(item => {
      formDataObj[item.name] = template[item.name] || "";
    });
    setFormData(formDataObj);
    setDialogOpen(true);
  };

  const cleanModalForm = () => {
    setModalBody(
      modalBody.map((item) => {
        item.value = "";
        return item;
      })
    );
  };

  const submitTemplate = (e) => {
    e.preventDefault();
    setModalSubmitting(true);
    
    // Convert form data to modal body format
    const updatedModalBody = modalBody.map(item => ({
      ...item,
      value: formData[item.name] || item.value
    }));
    
    const value = updatedModalBody.reduce((acc, item) => {
      acc[item.name] = item.value;
      return acc;
    }, {});
    
    //send the data post to endpoint /template
    fetch(process.env.REACT_APP_BACKEND_API + "/template" + currentFormAction, {
      method: currentFormMethod,
      headers: {
        "Content-Type": "application/json",
        'x-access-token': user.accessToken,
      },
      body: JSON.stringify(value),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (currentFormMethod == "POST") {
          setTemplates([...templates, data]);
          setTempTemplates([...tempTemplates, data]);
          setSnackbar({ open: true, message: 'Template creado correctamente', severity: 'success' });
        } else if (currentFormMethod == "PUT") {
          setTemplates(
            templates.map((template) => {
              if (template._id === data._id) {
                //only update the fields that are not empty
                for (const key in data) {
                  if (data[key] !== "") {
                    template[key] = data[key];
                  }
                }
                return template;
              }
              return template;
            })
          );
          setTempTemplates(
            templates.map((template) => {
              if (template._id === data._id) {
                //only update the fields that are not empty
                for (const key in data) {
                  if (data[key] !== "") {
                    template[key] = data[key];
                  }
                }
                return template;
              }
              return template;
            })
          );
          setSnackbar({ open: true, message: 'Template actualizado correctamente', severity: 'success' });
        }
        setDialogOpen(false);
        setFormData({});
        cleanModalForm();
        setModalSubmitting(false);
      })
      .catch((err) => {
        console.log(err);
        setSnackbar({ open: true, message: 'Error al procesar template', severity: 'error' });
        setModalSubmitting(false);
      });
  };

  const openModal = () => {
    const modal = document.querySelector(".main-modal");
    modal.classList.remove("fadeOut");
    modal.classList.add("fadeIn");
    modal.style.display = "flex";
  };

  const closeModal = () => {
    const modal = document.querySelector(".main-modal");
    modal.classList.remove("fadeIn");
    modal.classList.add("fadeOut");
    modal.style.display = "none";
    setModalBody(defaultModalBody);
  };

  const getTemplateStats = () => {
    const total = templates.length;
    const quickReply = templates.filter(t => t.type === 'quickreply').length;
    const button = templates.filter(t => !t.type || t.type === 'button').length;
    const withImage = templates.filter(t => t.image).length;
    
    return { total, quickReply, button, withImage };
  };

  const stats = getTemplateStats();

  const truncateText = (text, maxLength = 50) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  // WhatsApp Cloud API functions
  const fetchWaTemplates = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API + "/api/wa-templates", {
        headers: {
          "x-access-token": user.accessToken,
          "Content-Type": "application/json",
        },
      });
      setWaTemplates(response.data.templates || []);
    } catch (error) {
      console.error('Error fetching WhatsApp templates:', error);
      setSnackbar({ open: true, message: 'Error al cargar templates de WhatsApp', severity: 'error' });
    }
  };

  const fetchTemplateStats = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API + "/api/wa-templates/stats", {
        headers: {
          "x-access-token": user.accessToken,
          "Content-Type": "application/json",
        },
      });
      setTemplateStats(response.data);
    } catch (error) {
      console.error('Error fetching template stats:', error);
    }
  };

  const syncTemplates = async () => {
    setSyncLoading(true);
    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_API + "/api/wa-templates/sync", {}, {
        headers: {
          "x-access-token": user.accessToken,
          "Content-Type": "application/json",
        },
      });
      setSnackbar({ open: true, message: `Sincronizados ${response.data.synced} templates`, severity: 'success' });
      fetchWaTemplates();
      fetchTemplateStats();
    } catch (error) {
      console.error('Error syncing templates:', error);
      setSnackbar({ open: true, message: 'Error al sincronizar templates', severity: 'error' });
    } finally {
      setSyncLoading(false);
    }
  };

  const checkTemplateStatus = async (templateName) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API + `/api/wa-templates/check/${templateName}`, {
        headers: {
          "x-access-token": user.accessToken,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error checking template status:', error);
      return { approved: false, template: null };
    }
  };

  const getTemplatesByStatus = async (status) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API + `/api/wa-templates/status/${status}`, {
        headers: {
          "x-access-token": user.accessToken,
          "Content-Type": "application/json",
        },
      });
      return response.data.templates || [];
    } catch (error) {
      console.error('Error fetching templates by status:', error);
      return [];
    }
  };

  // Load WhatsApp templates and stats on component mount
  useEffect(() => {
    fetchWaTemplates();
    fetchTemplateStats();
  }, []);

  return (
    <Box sx={{ p: 3, backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: '#2c3e50', mb: 1 }}>
          Templates de WhatsApp
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Gestiona y edita plantillas de WhatsApp Business para tus campañas
        </Typography>
      </Box>

      {/* Statistics Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <StyledCard>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700 }}>
                    {stats.total}
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.8 }}>
                    Total Templates
                  </Typography>
                </Box>
                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 56, height: 56 }}>
                  <FontAwesomeIcon icon={faFileAlt} size="lg" />
                </Avatar>
              </Box>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <StyledCard>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700 }}>
                    {stats.button}
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.8 }}>
                    Templates con Botones
                  </Typography>
                </Box>
                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 56, height: 56 }}>
                  <FontAwesomeIcon icon={faComment} size="lg" />
                </Avatar>
              </Box>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <StyledCard>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700 }}>
                    {stats.quickReply}
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.8 }}>
                    Respuestas Rápidas
                  </Typography>
                </Box>
                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 56, height: 56 }}>
                  <FontAwesomeIcon icon={faReply} size="lg" />
                </Avatar>
              </Box>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <StyledCard>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700 }}>
                    {stats.withImage}
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.8 }}>
                    Con Imágenes
                  </Typography>
                </Box>
                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 56, height: 56 }}>
                  <FontAwesomeIcon icon={faImage} size="lg" />
                </Avatar>
              </Box>
            </CardContent>
          </StyledCard>
        </Grid>
      </Grid>

      {/* Search and Actions */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <SearchContainer sx={{ flex: 1, maxWidth: 400 }}>
          <FontAwesomeIcon icon={faSearch} style={{ color: '#6c757d', marginRight: '8px' }} />
          <TextField
            fullWidth
            placeholder="Buscar templates..."
            value={searchValue}
            onChange={searchTemplate}
            variant="standard"
            InputProps={{ disableUnderline: true }}
          />
        </SearchContainer>

        <Box sx={{ display: 'flex', gap: 2 }}>
          {/* WhatsApp Cloud API Controls */}
          <Button
            variant="outlined"
            startIcon={<FontAwesomeIcon icon={showWaTemplates ? faEye : faEye} />}
            onClick={() => setShowWaTemplates(!showWaTemplates)}
            sx={{ borderRadius: '8px' }}
          >
            {showWaTemplates ? 'Templates Locales' : 'Templates WhatsApp'}
          </Button>
          
          <Button
            variant="outlined"
            startIcon={<FontAwesomeIcon icon={syncLoading ? faSpinner : faCog} spin={syncLoading} />}
            onClick={syncTemplates}
            disabled={syncLoading}
            sx={{ borderRadius: '8px' }}
          >
            {syncLoading ? 'Sincronizando...' : 'Sincronizar'}
          </Button>

          <Button
            variant="outlined"
            startIcon={<FontAwesomeIcon icon={viewMode === 'table' ? faEye : faFilter} />}
            onClick={() => setViewMode(viewMode === 'table' ? 'grid' : 'table')}
            sx={{ borderRadius: '8px' }}
          >
            {viewMode === 'table' ? 'Vista Grid' : 'Vista Tabla'}
          </Button>
          
          <Button
            variant="contained"
            startIcon={<FontAwesomeIcon icon={faPlus} />}
            onClick={newTemplate}
            sx={{ 
              borderRadius: '8px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
              }
            }}
          >
            Nueva Plantilla
          </Button>
          <Button
            variant="contained"
            startIcon={<FontAwesomeIcon icon={faReply} />}
            onClick={newTemplateQuickReply}
            sx={{ 
              borderRadius: '8px',
              background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #218838 0%, #1ea085 100%)',
              }
            }}
          >
            Quick Reply
          </Button>
        </Box>
      </Box>

      {/* WhatsApp Template Status Filter */}
      {showWaTemplates && (
        <Box sx={{ mb: 3, p: 2, backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            Estado de Templates WhatsApp
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Chip 
              label={`Total: ${templateStats.total}`} 
              color="primary" 
              variant="outlined"
            />
            <Chip 
              label={`Aprobados: ${templateStats.approved}`} 
              color="success" 
              variant="outlined"
            />
            <Chip 
              label={`Pendientes: ${templateStats.pending}`} 
              color="warning" 
              variant="outlined"
            />
            <Chip 
              label={`Rechazados: ${templateStats.rejected}`} 
              color="error" 
              variant="outlined"
            />
            <Chip 
              label={`Deshabilitados: ${templateStats.disabled}`} 
              color="default" 
              variant="outlined"
            />
          </Box>
        </Box>
      )}

      {/* Content */}
      {viewMode === 'table' ? (
        /* Table View */
        <StyledTableContainer component={Paper}>
          {loading && <LinearProgress />}
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Nombre</StyledTableCell>
                <StyledTableCell>Tipo</StyledTableCell>
                <StyledTableCell>Body</StyledTableCell>
                <StyledTableCell>Imagen</StyledTableCell>
                <StyledTableCell>Parámetros</StyledTableCell>
                <StyledTableCell>Botones</StyledTableCell>
                <StyledTableCell align="center">Acciones</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                      <FontAwesomeIcon icon={faSpinner} spin />
                      <Typography>Cargando templates...</Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : templates.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                      <FontAwesomeIcon icon={faFileAlt} size="2x" style={{ color: '#ccc' }} />
                      <Typography variant="body1" color="text.secondary">
                        No se encontraron templates
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {searchValue ? 'Intenta ajustar tus criterios de búsqueda' : 'Crea tu primer template usando el botón de arriba'}
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                templates.map((template, key) => (
                  <TableRow key={template._id} hover>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Avatar sx={{ bgcolor: template.type === 'quickreply' ? '#28a745' : '#667eea' }}>
                          <FontAwesomeIcon icon={template.type === 'quickreply' ? faReply : faComment} />
                        </Avatar>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          {template.name}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Chip 
                        label={template.type ? template.type : "button"} 
                        color={template.type === 'quickreply' ? 'success' : 'primary'}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" color="text.secondary">
                        {truncateText(template.body, 60)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {template.image ? (
                        <Box sx={{ width: 60, height: 60, borderRadius: 1, overflow: 'hidden' }}>
                          <img 
                            src={template.image} 
                            alt={template.name}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        </Box>
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          Sin imagen
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {template.parameters ? 
                          template.parameters.slice(0, 3).map((param, idx) => (
                            <Chip key={idx} label={param.value} size="small" variant="outlined" />
                          ))
                          : <Typography variant="body2" color="text.secondary">Sin parámetros</Typography>
                        }
                        {template.parameters && template.parameters.length > 3 && (
                          <Chip label={`+${template.parameters.length - 3}`} size="small" />
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {template.buttonparameters ? 
                          template.buttonparameters.slice(0, 2).map((param, idx) => (
                            <Chip key={idx} label={param.value} size="small" variant="outlined" color="secondary" />
                          ))
                          : <Typography variant="body2" color="text.secondary">Sin botones</Typography>
                        }
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                        <Tooltip title="Editar">
                          <IconButton
                            onClick={editTemplate}
                            data-id={key}
                            size="small"
                            sx={{ color: '#667eea' }}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Eliminar">
                          <IconButton
                            onClick={deleteTemplate}
                            data-id={key}
                            size="small"
                            sx={{ color: '#dc3545' }}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </StyledTableContainer>
      ) : (
        /* Grid View */
        <Grid container spacing={3}>
          {loading ? (
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 4, gap: 2 }}>
                <FontAwesomeIcon icon={faSpinner} spin />
                <Typography>Cargando templates...</Typography>
              </Box>
            </Grid>
          ) : templates.length === 0 ? (
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4, gap: 2 }}>
                <FontAwesomeIcon icon={faFileAlt} size="2x" style={{ color: '#ccc' }} />
                <Typography variant="body1" color="text.secondary">
                  No se encontraron templates
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {searchValue ? 'Intenta ajustar tus criterios de búsqueda' : 'Crea tu primer template usando el botón de arriba'}
                </Typography>
              </Box>
            </Grid>
          ) : (
            templates.map((template, key) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={template._id}>
                <TemplateCard>
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Avatar sx={{ bgcolor: template.type === 'quickreply' ? '#28a745' : '#667eea', width: 32, height: 32 }}>
                          <FontAwesomeIcon icon={template.type === 'quickreply' ? faReply : faComment} size="sm" />
                        </Avatar>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          {template.name}
                        </Typography>
                      </Box>
                      <Chip 
                        label={template.type ? template.type : "button"} 
                        color={template.type === 'quickreply' ? 'success' : 'primary'}
                        size="small"
                      />
                    </Box>
                    
                    {template.image && (
                      <Box sx={{ mb: 2, borderRadius: 1, overflow: 'hidden', height: 120 }}>
                        <img 
                          src={template.image} 
                          alt={template.name}
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      </Box>
                    )}
                    
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2, minHeight: 40 }}>
                      {truncateText(template.body, 80)}
                    </Typography>
                    
                    <Divider sx={{ my: 1 }} />
                    
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 2 }}>
                      {template.parameters ? 
                        template.parameters.slice(0, 2).map((param, idx) => (
                          <Chip key={idx} label={param.value} size="small" variant="outlined" />
                        ))
                        : <Typography variant="caption" color="text.secondary">Sin parámetros</Typography>
                      }
                    </Box>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="caption" color="text.secondary">
                        {template.created_at}
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 0.5 }}>
                        <Tooltip title="Editar">
                          <IconButton
                            onClick={editTemplate}
                            data-id={key}
                            size="small"
                            sx={{ color: '#667eea' }}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Eliminar">
                          <IconButton
                            onClick={deleteTemplate}
                            data-id={key}
                            size="small"
                            sx={{ color: '#dc3545' }}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Box>
                  </CardContent>
                </TemplateCard>
              </Grid>
            ))
          )}
        </Grid>
      )}

      {/* WhatsApp Templates Section */}
      {showWaTemplates && (
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" sx={{ fontWeight: 600, color: '#2c3e50', mb: 3 }}>
            Templates de WhatsApp Cloud API
          </Typography>
          
          {viewMode === 'table' ? (
            /* WhatsApp Templates Table View */
            <StyledTableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Nombre</StyledTableCell>
                    <StyledTableCell>Estado</StyledTableCell>
                    <StyledTableCell>Categoría</StyledTableCell>
                    <StyledTableCell>Idioma</StyledTableCell>
                    <StyledTableCell>Componentes</StyledTableCell>
                    <StyledTableCell>Última Actualización</StyledTableCell>
                    <StyledTableCell align="center">Acciones</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {waTemplates.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                          <FontAwesomeIcon icon={faFileAlt} size="2x" style={{ color: '#ccc' }} />
                          <Typography variant="body1" color="text.secondary">
                            No se encontraron templates de WhatsApp
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Usa el botón "Sincronizar" para cargar templates desde WhatsApp Cloud API
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : (
                    waTemplates.map((template, key) => (
                      <TableRow key={template.wa_template_id || key} hover>
                        <TableCell>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Avatar sx={{ 
                              bgcolor: template.status === 'APPROVED' ? '#28a745' : 
                                       template.status === 'PENDING' ? '#ffc107' : 
                                       template.status === 'REJECTED' ? '#dc3545' : '#6c757d' 
                            }}>
                              <FontAwesomeIcon icon={faComment} />
                            </Avatar>
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                              {template.name}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Chip 
                            label={template.status} 
                            color={
                              template.status === 'APPROVED' ? 'success' : 
                              template.status === 'PENDING' ? 'warning' : 
                              template.status === 'REJECTED' ? 'error' : 'default'
                            }
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <Chip 
                            label={template.category} 
                            color="primary" 
                            variant="outlined"
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" color="text.secondary">
                            {template.language}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {template.components ? 
                              template.components.slice(0, 2).map((component, idx) => (
                                <Chip key={idx} label={component.type} size="small" variant="outlined" />
                              ))
                              : <Typography variant="body2" color="text.secondary">Sin componentes</Typography>
                            }
                            {template.components && template.components.length > 2 && (
                              <Chip label={`+${template.components.length - 2}`} size="small" />
                            )}
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" color="text.secondary">
                            {template.wa_updated_at ? new Date(template.wa_updated_at).toLocaleDateString() : 'N/A'}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                            <Tooltip title="Ver Detalles">
                              <IconButton
                                size="small"
                                sx={{ color: '#667eea' }}
                              >
                                <FontAwesomeIcon icon={faEye} />
                              </IconButton>
                            </Tooltip>
                            {template.status === 'APPROVED' && (
                              <Tooltip title="Usar Template">
                                <IconButton
                                  size="small"
                                  sx={{ color: '#28a745' }}
                                >
                                  <FontAwesomeIcon icon={faCheck} />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </StyledTableContainer>
          ) : (
            /* WhatsApp Templates Grid View */
            <Grid container spacing={3}>
              {waTemplates.length === 0 ? (
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4, gap: 2 }}>
                    <FontAwesomeIcon icon={faFileAlt} size="2x" style={{ color: '#ccc' }} />
                    <Typography variant="body1" color="text.secondary">
                      No se encontraron templates de WhatsApp
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Usa el botón "Sincronizar" para cargar templates desde WhatsApp Cloud API
                    </Typography>
                  </Box>
                </Grid>
              ) : (
                waTemplates.map((template, key) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={template.wa_template_id || key}>
                    <TemplateCard>
                      <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Avatar sx={{ 
                              bgcolor: template.status === 'APPROVED' ? '#28a745' : 
                                       template.status === 'PENDING' ? '#ffc107' : 
                                       template.status === 'REJECTED' ? '#dc3545' : '#6c757d',
                              width: 32, height: 32 
                            }}>
                              <FontAwesomeIcon icon={faComment} size="sm" />
                            </Avatar>
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>
                              {template.name}
                            </Typography>
                          </Box>
                          <Chip 
                            label={template.status} 
                            color={
                              template.status === 'APPROVED' ? 'success' : 
                              template.status === 'PENDING' ? 'warning' : 
                              template.status === 'REJECTED' ? 'error' : 'default'
                            }
                            size="small"
                          />
                        </Box>
                        
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                          Categoría: {template.category}
                        </Typography>
                        
                        <Divider sx={{ my: 1 }} />
                        
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 2 }}>
                          {template.components ? 
                            template.components.slice(0, 2).map((component, idx) => (
                              <Chip key={idx} label={component.type} size="small" variant="outlined" />
                            ))
                            : <Typography variant="caption" color="text.secondary">Sin componentes</Typography>
                          }
                        </Box>
                        
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Typography variant="caption" color="text.secondary">
                            {template.wa_updated_at ? new Date(template.wa_updated_at).toLocaleDateString() : 'N/A'}
                          </Typography>
                          <Box sx={{ display: 'flex', gap: 0.5 }}>
                            <Tooltip title="Ver Detalles">
                              <IconButton
                                size="small"
                                sx={{ color: '#667eea' }}
                              >
                                <FontAwesomeIcon icon={faEye} />
                              </IconButton>
                            </Tooltip>
                            {template.status === 'APPROVED' && (
                              <Tooltip title="Usar Template">
                                <IconButton
                                  size="small"
                                  sx={{ color: '#28a745' }}
                                >
                                  <FontAwesomeIcon icon={faCheck} />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Box>
                        </Box>
                      </CardContent>
                    </TemplateCard>
                  </Grid>
                ))
              )}
            </Grid>
          )}
        </Box>
      )}

      {/* Create/Edit Dialog */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          {currentTitle}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <TextField
              fullWidth
              label="Nombre de la Plantilla"
              value={formData.name || ""}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            />
            <TextField
              fullWidth
              multiline
              rows={6}
              label="Contenido del Mensaje"
              value={formData.body || ""}
              onChange={(e) => setFormData({ ...formData, body: e.target.value })}
              helperText="Usa {1}, {2}, etc. para parámetros dinámicos. Puedes usar *texto* para negrita y _texto_ para cursiva."
            />
            <TextField
              fullWidth
              label="URL de Imagen (opcional)"
              value={formData.image || ""}
              onChange={(e) => setFormData({ ...formData, image: e.target.value })}
            />
            <TextField
              fullWidth
              label="Parámetros (separados por comas)"
              value={formData.parameters ? 
                (Array.isArray(formData.parameters) ? 
                  formData.parameters.map(p => p.value || p).join(', ') : 
                  formData.parameters) : ""}
              onChange={(e) => setFormData({
                ...formData,
                parameters: e.target.value.split(',').map(param => ({ value: param.trim() }))
              })}
            />
            <TextField
              fullWidth
              label="Parámetros de Botón (separados por comas)"
              value={formData.buttonparameters ? 
                (Array.isArray(formData.buttonparameters) ? 
                  formData.buttonparameters.map(p => p.value || p).join(', ') : 
                  formData.buttonparameters) : ""}
              onChange={(e) => setFormData({
                ...formData,
                buttonparameters: e.target.value.split(',').map(param => ({ value: param.trim() }))
              })}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.is_monday || false}
                  onChange={(e) => setFormData({ ...formData, is_monday: e.target.checked })}
                />
              }
              label="Es plantilla de Monday?"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.is_flow || false}
                  onChange={(e) => setFormData({ ...formData, is_flow: e.target.checked })}
                />
              }
              label="Es plantilla de flow?"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancelar</Button>
          <Button onClick={submitTemplate} variant="contained" disabled={modalSubmitting}>
            {modalSubmitting ? 'Guardando...' : currentButtonText}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert 
          onClose={() => setSnackbar({ ...snackbar, open: false })} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <NewModelModal
        title={currentTitle}
        onClose={closeModal}
        body={modalBody}
        onSubmit={submitTemplate}
        modalResult={modalResult}
        onChange={formOnChange}
        method={currentFormMethod}
        action={currentFormAction}
        buttonText={currentButtonText}
      />
    </Box>
  );
}
